import { render } from "./AfyaNafuu.vue?vue&type=template&id=3c142e97&scoped=true"
import script from "./AfyaNafuu.vue?vue&type=script&lang=js"
export * from "./AfyaNafuu.vue?vue&type=script&lang=js"

import "./AfyaNafuu.vue?vue&type=style&index=0&id=3c142e97&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c142e97"]])

export default __exports__